
import { baseUrl } from "../../constants";
import { 
    getDDDeptCall, getDDCompCall, getDDLocCall 
} from "../../redux/actions/dropDown";
import { setFullLoad } from "../../redux/actions/common";

export default {
    "formTitle": "Add Area",
    "tableTitle": "Area List",
    "apiDetails": {
        startUp: (dispatch) => {
            dispatch(setFullLoad(true));
            const dropDownArr = [
                getDDCompCall //, getDDDeptCall, getDDLocCall
            ];
            setTimeout(()=>{
                dispatch(setFullLoad(false));
            }, 500);
            dropDownArr.forEach((func,) => {
                    dispatch(func());
            });
        },
        list: {
            url: `${baseUrl}/api/mms/area/list`,
            payload: {
                "search": "",
                "offset": 0,
                "limit": 50,
                "sort": "DESC",
                "column": "id"
            }
        },
        add: `${baseUrl}/api/mms/area`,
        edit: `${baseUrl}/api/mms/area/edit`,
        delete: `${baseUrl}/api/mms/area/remove`
    },
    "tableCol": [
        {
            name: 'Company',
            selector: row => row.comp_id,
            sortable: true
        },
        {
            name: 'Location',
            selector: row => row.loc_id,
            sortable: true
        },
        {
            name: 'Department',
            selector: row => row.department_id,
            sortable: true
        },
        {
            name: 'Area',
            selector: row => row.name,
            sortable: true
        }
    ],
    "formData": [
        {
            "formType": "flex",
            "formFields": [
                {
                    type: 'select',
                    label: 'Company',
                    name: 'comp_id',
                    "options": []
                },
                {
                    type: 'select',
                    label: 'Location',
                    name: 'loc_id',
                    "options": []
                },
                {
                    type: 'select',
                    label: 'Department',
                    name: 'department_id',
                    "options": [],
                    // "required": true
                },
                {
                    type: 'text',
                    label: 'Area',
                    name: 'name',
                    "required": true
                }
            ]
        }
    ],
    "mockData": [{
        "department": 1,
        "area": "dgdg"
    }]
}